import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import PercentageCalculator from '../../components/PercentageCalculator';

const PercentageCalc: React.FC = () => (
  <ToolLayout
    title="Percentage Calculator - Quick Percent Math | AllTools"
    description="Calculate percentages, percentage increase/decrease, and percent of values. Free percentage calculator."
    canonicalPath="/percentage-calculator"
  >
    <PercentageCalculator />
  </ToolLayout>
);

export default PercentageCalc;
